import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, UserRole } from '../../stores/authStore';

interface ImpactPlanRouteProps {
  children: React.ReactNode;
}

const ImpactPlanRoute: React.FC<ImpactPlanRouteProps> = ({ children }) => {
  const { user } = useAuthStore();

  // Check if user has access to Impact Plan page
  // Allow: Monitor Manager (USER), Customer Support, Admin, Super Admin, Auditor
  // Exclude: Sales (ACCOUNT_MANAGER role)
  const hasImpactPlanAccess = user && (
    user.role === UserRole.USER || // Monitor Manager
    user.role === UserRole.CUSTOMER_SUPPORT ||
    user.role === UserRole.ADMIN ||
    user.role === UserRole.SUPER_ADMIN ||
    user.role === UserRole.AUDITOR ||
    user.hasAdminAccess ||
    user.hasAuditAccess
  ) && user.role !== UserRole.ACCOUNT_MANAGER; // Explicitly exclude Account Manager (Sales)

  if (!hasImpactPlanAccess) {
    // Redirect to dashboard if user doesn't have Impact Plan access
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ImpactPlanRoute;

